import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Vehicle Album',
  name: 'vehicleAlbum',
  type: 'object',
  fields: [
    defineField({
      name: 'album',
      type: 'reference',
      to: [{ type: 'album' }],
    }),
  ],
  preview: {
    select: {
      make: 'album.vehicle.make.name',
      model: 'album.vehicle.model.name',
      generation: 'album.vehicle.generation.name',
      media: 'album.images[0].asset',
      hide: 'album.hide',
      color: 'album.color.name',
    },
    prepare(selection) {
      const {
        make = '',
        model = '',
        generation = '',
        hide = false,
        media = false,
        color = '',
      } = selection
      const title = !`${make}${model}${generation}`.trim().length
        ? 'New Album'
        : `${hide ? '[Hidden] ' : ''}${color} ${make} ${model} ${generation}`

      return {
        title,
        subtitle: 'Vehicle album',
        media,
      }
    },
  },
})